import React from "react";
import { useFela } from "react-fela";
import useTranslation from "next-translate/useTranslation";

import { Link } from "@/components/Link";
import { useTheme } from "../../../hooks/useTheme";
import { ISelectFormatElement } from "../types";
import { StyledIconWrapper, Icon } from "../../../components/Icon";

export const ListElement: React.FC<ISelectFormatElement> = ({
  iconTypeFrom,
  iconTypeTo,
  text,
  href,
  children,
  ...rest
}) => {
  const { css } = useFela();
  const { colors, bp, fonts } = useTheme();
  const { t } = useTranslation("section/selectFormat");

  return (
    <>
      <li
        className={css({
          marginTop: 29,
          marginBottom: 25,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          [bp.FROM_DESKTOP]: {
            flexDirection: "row",
          },
        })}
        {...rest}
      >
        <div
          className={css({
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: 10,
            marginRight: 10,
            [bp.FROM_TABLET]: {
              flexDirection: "row",
            },
            [bp.FROM_DESKTOP]: {
              marginBottom: 0,
            },
          })}
        >
          <div
            className={css({
              display: "flex",
              alignItems: "center",
            })}
          >
            <StyledIconWrapper height={46} width={46}>
              <Icon iconType={iconTypeFrom} />
            </StyledIconWrapper>
            <StyledIconWrapper customStyle={{ margin: "0 12px" }}>
              <Icon iconType="ARROW-RIGHT-GREY" />
            </StyledIconWrapper>
            <StyledIconWrapper height={46} width={46}>
              <Icon iconType={iconTypeTo} />
            </StyledIconWrapper>
          </div>

          <p
            className={css({
              display: "flex",
              alignItems: "center",
            })}
          >
            <span
              className={css({
                fontSize: 24,
                marginLeft: 10,
                fontFamily: fonts.PRIMARY_FONT,
                fontWeight: "bold",
                color: colors.MAASTRICHT_BLUE,
                textAlign: "center",
                [bp.FROM_DESKTOP]: {
                  marginLeft: 46,
                },
              })}
            >
              {text}
            </span>
          </p>
        </div>
        <Link
          href={href}
          customStyle={{
            width: 148,
            display: "block",
            flexShrink: 0,
            textAlign: "center",
            textDecoration: "none",
            padding: "13px 0",
            border: "none",
            borderRadius: 8,
            backgroundColor: colors.ORANGE,
            fontSize: 14,
            fontWeight: "bold",
            textTransform: "uppercase",
            color: colors.WHITE,
            [bp.FROM_DESKTOP]: {
              marginLeft: "auto",
            },
            [bp.FROM_LARGE_DESKTOP]: {
              width: 183,
            },
          }}
        >
          {t("convertNow")}
        </Link>
      </li>
      <hr
        className={css({
          width: "88%",
          color: "#979797",
          opacity: "0.21",
          nested: {
            ":last-child": {
              display: "none",
            },
          },
        })}
      />
    </>
  );
};
